import { DOCUMENTO_CONCILIABLE } from "api/Types/DocumentoConciliable"
import { TFunction } from "i18next"

export const DOCUMENTO_CONCILIABLE_TYPE = (t: TFunction) => ({
  [DOCUMENTO_CONCILIABLE.FACTURA]: {
    label: `${t("bancos.conciliationType.invoice")}`,
    message: `${t("bancos.conciliationType.msgSucessDevolucionDes")}`,
  },
  [DOCUMENTO_CONCILIABLE.DEVOLUCION]: {
    label: `${t("bancos.conciliationType.devolution")}`,
    message: `${t("bancos.conciliationType.msgSucessDevolucionDes")}`,
  },
  [DOCUMENTO_CONCILIABLE.AMORTIZACION]: {
    label: `${t("bancos.conciliationType.amortization")}`,
    message: `${t("bancos.conciliationType.msgSucessAmortizacionDes")}`,
  },
  [DOCUMENTO_CONCILIABLE.FLUJO_TESORERIA]: {
    label: `${t("bancos.conciliationType.cashFlow")}`,
    message: `${t("bancos.conciliationType.msgSucessFlujoDes")}`,
  },
  [DOCUMENTO_CONCILIABLE.LINEAS_ASIENTO_CONTABLE]: {
    label: `${t("bancos.conciliationType.accountingLine")}`,
    message: `${t("bancos.conciliationType.msgSucessDevolucionDes")}`,
  },
})
